import React from 'react';
import {observer} from 'mobx-react';
import {OrbitSuspense} from '../base-components/orbit-suspense/orbit-suspense';
import {RoutedComponent} from '../base-components/routed-component/routed.component';

const CmsPageComponent = React.lazy(
  () => import("../cms-page/cms-page.component").then(({CmsPageComponent}) => ({default: CmsPageComponent}))
);

@observer
export class ArenaHostComponent extends RoutedComponent<{}> {
  render() {
    if(this.services.cmsPages.currentPage) {
      return (<OrbitSuspense><CmsPageComponent/></OrbitSuspense>);
    } else {

      let arena = this.services.arenas.getCurrentArena();

      return arena?.renderArena() || null;
    }
  }
}
